import { Component, Input, Output, EventEmitter, ElementRef, ViewChild, Renderer2, OnChanges } from '@angular/core';
import { OnInit, SimpleChanges } from '@angular/core/src/metadata/lifecycle_hooks';

import * as L from 'leaflet';
import { Router, NavigationEnd } from '@angular/router';
import { MapaService } from './mapa.service';
import { Activo } from '../../../core/modelos/activo';
import { NotificacionesService } from '../../../core/notificaciones/notificaciones.service';
import { User } from '../../../core/modelos/user';
import { SelectClientModalService } from '../../../core/select-client-modal/select-client-modal.service';
import { Cliente } from '../../../core/modelos/cliente';
import { ClientesComponent } from '../../content/clientes/clientes.component';
import { ClientesService } from '../../content/clientes/clientes.service';
import { FileManagerService } from '../../content/file-manager/file-manager.service';
import { ToolbarService } from '../../toolbar/toolbar.service';

@Component({
    selector: 'fuse-mapa',
    templateUrl: './mapa.component.html',
    styleUrls: ['./mapa.component.scss']
})
export class MapaComponent implements OnInit, OnChanges {

    marcadoresActivos: L.Marker[];

    // Variables que referencian el mapa, para manipular estilos.
    @ViewChild('mapa') mapa: ElementRef;
    markerContainer: any;
    marcas: HTMLCollection;

    // Indicador del índice del activo seleccionado, para resaltarlo
    @Input() indexSeleccion: number;

    showSelected = false;
    activeItem: Activo;

    // Variable con el objeto completo desde API de los marcadores
    marcadores: Array<Activo>;
    @Output() onMarcadores = new EventEmitter<any>();

    // Indicador del índice del popUp abierto, para mostrar project card al pinchar en la imagen-link
    indexPopup: number;
    // Variable de salida con el índice seleccionado para mostrar project card
    @Output() onIndexPopup = new EventEmitter<any>();

    Mapbox = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      id: 'mapbox/light-v10',
      detectRetina: true,
      accessToken: 'pk.eyJ1IjoiYmltdXgiLCJhIjoiY2swbmozcndlMDBjeDNuczNscTZzaXEwYyJ9.oMM71W-skMU6IN0XUZJzGQ'
    });

    // Usuario conectado
    user: User;

    esAdminBod: boolean;

    activos: Array<Activo>;
    popup: L.Popup;
    popupAbierta: L.Popup;

    constructor(
        private renderer: Renderer2,
        private mapaService: MapaService,
        private notificaciones: NotificacionesService,
        private selectClientModal: SelectClientModalService,
        private clientesService: ClientesService,
        private fileManager: FileManagerService,
        private toolbarService: ToolbarService,
        private router: Router
    ) {
        this.user = JSON.parse(sessionStorage.getItem('usuarioLogueado')).usuario;

        this.mapaService.getIndexPopup().subscribe(
            data => {
                this.indexPopup = data;

                if (this.indexPopup > -1) {

                    setTimeout(() => {

                        this.onIndexPopup.emit(this.indexPopup);

                    }, 0);
                }
            }
        );

        this.esAdminBod = this.user.rol.id === 1;

        const cliente = this.user.cliente;

        if (this.esAdminBod && !cliente) {
            // if no cliente seleccionado
            this.openModal();
        } else if (this.esAdminBod && cliente) {
            this.setClienteAdmin(cliente);
        } else {
            this.rellenarMapa();
        }

        this.router.events.subscribe((e: any) => {
          // If it is a NavigationEnd event re-initalise the component
          if (e instanceof NavigationEnd) {
              this.showSelected = false;
              this.activeItem = undefined;

              if (this.mapaService.map) {
                setTimeout(() => {
                  this.mapaService.map.invalidateSize();
                }, 0)
              }
          }
        });
    }

    ngOnInit() {
        // console.log(this.user.usuario);

    }

    rellenarMapa() {
        this.mapaService.getActivos().subscribe(
            data => {
                if (data.success) {
                    // Aqui se guardan los activos, ya filtrados por el back segun los que puede ver el usuario
                    const activos = data.items;
                    this.activos = activos;

                    // A partir de aqui, copio lo que tenias
                    this.marcadores = activos;

                    if (this.marcadores.length) {

                        this.onMarcadores.emit(this.marcadores);
                        this.mapaService.fillBounds(this.marcadores);

                    }

                    const map = L.map('mapa', {
                        zoomControl: true,
                        center: L.latLng([40.411561, -3.645266]), // Fidelis Consultores
                        zoom: 2,
                        minZoom: 2,
                        maxZoom: 17,
                        layers: [this.Mapbox],
                        attributionControl: false
                    })

                    // Añado escala métrica
                    L.control.scale().addTo(map);

                    this.mapaService.map = map;

                    // Añado los marcadores
                    this.mapaService.addMarkers(this.marcadores);

                    // Centro el mapa
                    this.mapaService.fitBounds();

                    // Fijo los límites
                    this.mapaService.setLimites();

                    // Añado eventos de zoom
                    this.mapaService.mapEvents();


                    // Selecciono contenedor de marcadores
                    this.markerContainer = this.mapa.nativeElement.querySelector('.leaflet-marker-pane');

                    // Selecciono los marcadores
                    this.marcas = this.markerContainer.children;

                } else {
                    // CONTROLAR ERROR
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.MensajesGenerales.ErrorDesconocido);
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
            }
        );

    }

    ngOnChanges(changes: SimpleChanges) {

        if (changes.indexSeleccion && !changes.indexSeleccion.firstChange) {

            const currentValue = changes.indexSeleccion.currentValue;
            const previousValue = changes.indexSeleccion.previousValue;

            if (currentValue !== undefined) {

                if (currentValue === -1) {

                    this.renderer.removeClass(this.marcas[previousValue], 'resaltarMarcador');
                    this.showSelected = false;
                    // this.popup.remove();

                } else {

                    this.renderer.addClass(this.marcas[currentValue], 'resaltarMarcador');
                    this.showSelected = true;
                    this.activeItem = this.activos[currentValue];

                    this.mapaService.map.invalidateSize();

                    /* const m = this.activos[currentValue];
                    m.latitud += 0.1;
                    const kpiSuperficie = m.kpis ? m.kpis.filter(kpi => kpi.clave === 1) : 0;
                    const superficie = kpiSuperficie[0] ? kpiSuperficie[0].valor : '';

                    this.popup = L.popup()
                    .setContent(
                    `
                        <div class="fuse-card">

                            <div class="p-16 titulo-popup" fxLayout="row">
                                <div class="h2">${m.nombre}</div>
                            </div>

                            <table class="simple">
                                <tbody>
                                    <tr>
                                        <td>Tipology</td>
                                        <td>${m.tipologia.nombre}</td>
                                    </tr>
                                    <tr>
                                        <td>Localización</td>
                                        <td>${m.ciudad}</td>
                                    </tr>
                                    <tr>
                                        <td>Superficie</td>
                                        <td>${superficie}</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    `)
                    .setLatLng(this.mapaService.formatearLatLong(m))
                    .openOn(this.mapaService.map); */
                }

                if (previousValue !== undefined && previousValue !== -1) {

                    this.renderer.removeClass(this.marcas[previousValue], 'resaltarMarcador');
                    this.showSelected = false;
                }
            }
        }

    }

    verInfo() {
    }

    onClick() {
        this.onIndexPopup.emit(this.indexPopup);
    }

    openModal() {
        this.selectClientModal.openModal().subscribe(
            (cliente: Cliente) => {
                this.setClienteAdmin(cliente);
            }
        );
    }

    destruir() {
        this.mapaService.destroy();
    }

    setClienteAdmin(cliente: Cliente) {
        this.clientesService.adminCambiarCliente(cliente.id).subscribe(
            data => {
                if (data.success) {
                    sessionStorage.setItem('usuarioLogueado', JSON.stringify({ 'usuario': data.items }));
                    ClientesComponent.cambiarCliente(cliente);
                    this.fileManager.setClienteBucket(cliente);
                    this.toolbarService.setClienteAdmin(cliente);
                    this.rellenarMapa();
                }
                else {
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Clientes.SinClientes);
                }
            },
            err => {
                this.notificaciones.errorServidor(err.status);
            }
        );

    }
}



// WEBPACK FOOTER //
// ./src/app/main/components/mapa/mapa.component.ts